// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2

console.log(
  `%c

          ______   .______    _______ .__   __. .___________.    ___       __       __  ___
         /  __  \\  |   _  \\  |   ____||  \\ |  | |           |   /   \\     |  |     |  |/  /
        |  |  |  | |  |_)  | |  |__   |   \\|  | \`---|  |----\`  /  ^  \\    |  |     |  '  /
        |  |  |  | |   ___/  |   __|  |  . \`  |     |  |      /  /_\\  \\   |  |     |    <
        |  \`--'  | |  |      |  |____ |  |\\   |     |  |     /  _____  \\  |  \`----.|  .  \\
         \\______/  | _|      |_______||__| \\__|     |__|    /__/     \\__\\ |_______||__|\\__\\

                                      %cCode with %c♥%c️ in Berlin
`,
  'background-color: #000; color: #FFE81F;',
  'background-color: #000; color: #fff;',
  'background-color: #000; color: #f00',
  'background-color: #000; color: #fff;'
);
